import { EngineMessageSubject } from '@framework/engine';
import { groupBy, maxBy, sumBy } from 'lodash';
import { IMapWidget } from '../../IMapWidget';
import { IMapCompetenceIntersectionItem } from './IMapCompetenceIntersectionItem';

export function sendMapIntersectionCompetenceMessage(
  widget: IMapWidget,
  intersectionItems: IMapCompetenceIntersectionItem[] | null,
) {
  if (!intersectionItems) return;
  if (!widget.competence?.enabled) return;
  console.log(`[Map.competence] Ricevuti ${intersectionItems.length} elementi di intersezione`, { intersectionItems }); // prettier-ignore

  // Filtri le aree che hanno la competenza
  const itemsWithCompetence = intersectionItems.filter(
    item => item.competence != null,
  );
  // Raggruppa le aree per competenza
  const competenceGroups = groupBy(
    itemsWithCompetence,
    item => item.competence,
  );
  // Ora per ogni competenza calcola l'area totale
  const competenceAreas = Object.entries(competenceGroups).map(
    ([competence, items]) => ({
      competence,
      affectedArea: sumBy(items, item => item.affectedArea),
    }),
  );
  // Se non ci sono aree con competenza non fare nulla
  if (competenceAreas.length === 0) return;

  const highestCompetenceEntry = maxBy(
    competenceAreas,
    area => area.affectedArea,
  );
  if (highestCompetenceEntry?.competence == null) return;

  console.log(`[Map.competence] Riconosciuta competenza ${highestCompetenceEntry.competence} con area ${highestCompetenceEntry.affectedArea}`); // prettier-ignore
  EngineMessageSubject.next({
    type: 'competencePicked',
    payload: {
      competenceCode: highestCompetenceEntry.competence,
    },
  });
}
